import { useMutation, useQueryClient } from 'react-query';
import { personKeys } from '../cache-keys/personKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { insurance_api } from '@axo/shared/data-access/api';

export function useUpdateInsurance() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(insurance_api.patchInsurance(api), {
    onSuccess: (result) => {
      client.invalidateQueries(
        personKeys.insurance({
          personID: result.PersonID,
        })
      );
    },
  });
}
